
import React, { useState } from 'react';

interface DealsHeroProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

export default function DealsHero({ searchQuery, onSearchChange }: DealsHeroProps) {
  const [inputValue, setInputValue] = useState(searchQuery);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // Guard against empty submissions if needed
    if (inputValue.trim() === '') {
      // Optional: you could show a toast or simply ignore
      return;
    }
    onSearchChange(inputValue);
  };

  return (
    <section className="relative pt-28 pb-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e94941011b7be05b5da2b318a2bf9d34.jpg"
          alt="Local deals and coupons in Roseville California"
          title="Roseville CA local deals coupons savings"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/85 via-gray-900/70 to-gray-900/50"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="max-w-2xl">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 bg-amber-500 rounded-full flex items-center justify-center">
              <i className="ri-coupon-3-line text-white text-lg"></i>
            </div>
            <span className="text-amber-400 font-semibold text-sm uppercase tracking-wider">
              Local Savings
            </span>
          </div>

          <h1 className="text-5xl font-bold text-white mb-4 leading-tight">
            Deals & <span className="text-amber-400">Coupons</span>
          </h1>

          <p className="text-lg text-white/80 mb-8 leading-relaxed">
            Save big at your favorite Roseville businesses. Exclusive discounts, limited-time offers,
            and coupon codes from trusted local partners.
          </p>

          <form
            onSubmit={handleSubmit}
            className="flex items-center bg-white rounded-xl overflow-hidden shadow-xl max-w-xl"
          >
            <div className="flex items-center flex-1 px-4 py-3.5">
              <i className="ri-search-line text-gray-400 text-lg mr-3"></i>
              <input
                type="text"
                placeholder="Search deals, businesses, or categories..."
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                className="w-full text-sm text-gray-800 placeholder-gray-400 outline-none bg-transparent"
              />
            </div>
            <button
              type="submit"
              className="whitespace-nowrap px-6 py-3.5 bg-teal-600 text-white text-sm font-semibold hover:bg-teal-700 transition-colors cursor-pointer"
            >
              Search
            </button>
          </form>

          <div className="flex flex-wrap gap-5 mt-8 text-white/90 text-sm">
            <div className="flex items-center gap-2">
              <i className="ri-price-tag-3-line text-amber-400"></i>
              <span>
                <strong>12+</strong> Active Deals
              </span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-store-2-line text-amber-400"></i>
              <span>
                <strong>10+</strong> Local Businesses
              </span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-money-dollar-circle-line text-amber-400"></i>
              <span>
                Up to <strong>100% Off</strong>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
